class SummaryDataCtrl {
  constructor($scope, $http, $element) {
    var self = this;

    self.state = {
      isEditable: ''
    };
    self.data = {};
    self.data.consents = {};
    self.candidate = {};
    self.price = {};
    self.consents = {};
    self.checks = {};
    self.sku = '';
    self.allConsets = false;

    self.clickEdit = function (section) {
      self.state.isEditable = section;
    };
    self.clickCancel = function (section) {
      self.state.isEditable = '';
    };
    self.clickSave = function (section) {
      $('form').submit();
    };
    self.clickHelpCheckbox = function(event) {
      $(event.target).parent().toggleClass('is-collapsed');

    };

    self.toggleCheckboxes = function () {
      self.allConsets = !self.allConsets;
      for (var property in self.checks) {
        if (self.checks.hasOwnProperty(property)) {
          self.checks[property] = self.allConsets;
        }
      }
    };

    self.init = function() {
      if (typeof window.candidate === 'object') {
          self.candidate = angular.merge(self.candidate, window.candidate);
          self.price = angular.merge(self.price, window.candidate.payment);
          self.consents = angular.merge(window.consents);
      }
      self.sku = window.sku;
    };
  }
}

SummaryDataCtrl.$inject = ['$scope', '$http', '$element'];

export default SummaryDataCtrl;
